import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import {
  RecommendedDocsClient,
  recommendedDocsApiRef,
} from './recommendedDocsApi';

const recommendedDocsPage = PageBlueprint.make({
  name: 'recommended-docs',
  params: {
    path: '/admin/recommended-docs',
    title: 'Recommended Documentation',
    icon: <LibraryAddCheckIcon />,
    loader: () =>
      import('./RecommendedDocsAdminPage').then(
        m => <m.RecommendedDocsAdminPage />,
      ),
  },
});

const recommendedDocsApi = ApiBlueprint.make({
  name: 'recommended-docs',
  params: define =>
    define({
      api: recommendedDocsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RecommendedDocsClient({ discoveryApi, fetchApi }),
    }),
});

export const recommendedDocsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [recommendedDocsPage, recommendedDocsApi],
});
